// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Avatar_avatarContainer__M9HHd","avatarBox":"Avatar_avatarBox__OeykC","onlinePin":"Avatar_onlinePin__jtq1A","avatarImage":"Avatar_avatarImage__kolY1"};